// Firebase initialization for frontend auth (Identity Platform)
// Uses environment variables:
//  - REACT_APP_FIREBASE_API_KEY
//  - REACT_APP_FIREBASE_AUTH_DOMAIN
//  - REACT_APP_FIREBASE_PROJECT_ID
// Optionally:
//  - REACT_APP_FIREBASE_APP_ID, REACT_APP_FIREBASE_MESSAGING_SENDER_ID

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export async function getIdTokenSafe(forceRefresh = false) {
  try {
    // If auth state is ready and user exists, return token
    if (auth.currentUser) {
      return await auth.currentUser.getIdToken(forceRefresh);
    }
    // Otherwise wait briefly for auth state to initialize
    const token = await new Promise((resolve) => {
      const timeout = setTimeout(() => {
        unsubscribe();
        resolve(null);
      }, 1500);
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        unsubscribe();
        clearTimeout(timeout);
        if (!user) return resolve(null);
        try {
          const t = await user.getIdToken(forceRefresh);
          resolve(t);
        } catch {
          resolve(null);
        }
      });
    });
    return token;
  } catch {
    return null;
  }
}

export default app;


